import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { GlobalStyle } from "../../components/Layout";
import { loginUser, useAuthDispatch } from "../../context";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useAuthDispatch();
  let navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      let response = await loginUser(dispatch, { email, password });
      if (!response.token) {
        document.getElementById("error").innerHTML = "Error al iniciar sesion";
      } else {
        navigate("/");
      }
    } catch (error) {
      document.getElementById("error").innerHTML = "Error al iniciar sesion";
      console.log(error);
    }
  };

  return (
    <Wrapper>
      <GlobalStyle />
      <LoginCard>
        <h1>La Usina</h1>
        <Subtitle>Inicia sesión para continuar</Subtitle>
        <form onSubmit={handleLogin}>
          <Field>
            <label htmlFor="email">Usuario</label>
            <input
              type="text"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <Field>
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          <SubmitBtn type="submit">Iniciar sesión</SubmitBtn>
          <p id="error"></p>
        </form>
      </LoginCard>
    </Wrapper>
  );
}

export default Login;

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
  background: var(--color-bg);
`;

const LoginCard = styled.div`
  width: 100%;
  max-width: 380px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--space-6) var(--space-5);

  h1 {
    margin: 0 0 var(--space-1);
    color: var(--color-primary);
    text-align: center;
  }

  form {
    width: 100%;
    gap: var(--space-3);
    margin-top: var(--space-4);
  }

  #error {
    color: var(--color-danger);
    font-size: 0.9rem;
    text-align: center;
    min-height: 1.2rem;
    margin: var(--space-2) 0 0;
  }
`;

const Subtitle = styled.p`
  text-align: center;
  color: var(--color-muted);
  font-size: 0.95rem;
  margin: 0;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  width: 100%;

  input {
    width: 100%;
  }
`;

const SubmitBtn = styled.button`
  width: 100%;
  margin-top: var(--space-2);
  padding: var(--space-3);
  background: var(--color-primary);
  color: #fff;
  border: 1px solid var(--color-primary);
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;
  :hover {
    background: var(--color-primary-strong);
    border-color: var(--color-primary-strong);
    box-shadow: var(--shadow-sm);
  }
`;
